import React from 'react';
import DynamicChart from './DynamicChart';
import { validateChartConfig } from './validateChartConfig';
import { HiOutlineRefresh, HiOutlineStar, HiStar } from 'react-icons/hi';
import { HiOutlineChat } from 'react-icons/hi';
import './ChatBubble.css';

const ChatBubble = ({ message, onRetry, onPin, onActionClick, isPinned }) => {
  const isUser = message.sender === 'user';
  
  // Format simple markdown bold logic
  const renderText = (text) => {
    if (!text) return null;
    const parts = text.split(/(\*\*.*?\*\*)/g);
    return parts.map((part, index) => {
      if (part.startsWith('**') && part.endsWith('**')) {
        return <strong key={index}>{part.slice(2, -2)}</strong>;
      }
      return <span key={index}>{part}</span>;
    });
  };

  const hasChart = message.chartConfig && validateChartConfig(message.chartConfig);

  return (
    <div className={`chat-bubble-container ${isUser ? 'user' : 'ai'}`}>
      {!isUser && <div className="chat-avatar"><HiOutlineChat /></div>}
      <div className="chat-bubble-content">
        <div className={`chat-bubble ${isUser ? 'user-bubble' : 'ai-bubble'}`}>
          {message.text && <div className="chat-text">{renderText(message.text)}</div>}
          
          {hasChart && (
            <div className="chat-chart-area">
              <DynamicChart config={message.chartConfig} compact={true} />
            </div>
          )}

          {!isUser && message.actions && message.actions.length > 0 && (
            <div className="chat-actions">
              {message.actions.map((action, i) => (
                <button 
                  key={i} 
                  className="chat-action-btn"
                  onClick={() => onActionClick && onActionClick(action)}
                >
                  {action.label}
                </button>
              ))}
            </div>
          )}
        </div>
        
        {!isUser && (
          <div className="chat-meta">
            <span className="chat-time">{new Date(message.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
            <div className="chat-controls">
              {onRetry && (
                <button className="chat-control-btn" title="Retry" onClick={() => onRetry(message.id)}>
                  <HiOutlineRefresh />
                </button>
              )}
              {hasChart && onPin && (
                <button className={`chat-control-btn ${isPinned ? 'pinned' : ''}`} title={isPinned ? 'Unpin' : 'Pin'} onClick={() => onPin(message)}>
                  {isPinned ? <HiStar /> : <HiOutlineStar />}
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatBubble;
